/**
 * Silver plan SMS unit estimates — shared by fees, students, and class pages.
 */

import axios from 'axios';

const API_BASE = process.env.REACT_APP_API_URL || '';

export function isSilverPlanSchool(school) {
    if (!school) return false;
    if (String(school.country || '').trim().toUpperCase() === 'LR') return false;
    return String(school.subscriptionPackage || 'per_student').toLowerCase() === 'fixed';
}

export function canAffordSms(estimate) {
    if (!estimate || !estimate.wallet?.packageB) return true;
    return (estimate.unitsRequired || 0) <= (estimate.wallet.balance || 0);
}

export function smsEstimateHint(estimate, label = 'recipients') {
    if (!estimate || !estimate.wallet?.packageB) return '';
    const need = estimate.unitsRequired || 0;
    const count = estimate.recipientCount || 0;
    const balance = estimate.wallet.balance || 0;
    const short =
        need > balance ? ' Purchase units on Pricing before sending.' : '';
    return `Needs ${need} SMS units (${count} ${label}). Balance: ${balance}.${short}`;
}

export async function estimateBulkParentSms({ schoolID, message, class_ }) {
    const res = await axios.post(`${API_BASE}/api/students/estimate-bulk-sms-units`, {
        schoolID,
        message,
        ...(class_ ? { class_ } : {}),
    });
    return res.data;
}

export async function estimateSmsUnitsGeneric({ schoolID, items, message, recipientCount, phones }) {
    const res = await axios.post(`${API_BASE}/api/schools/estimate-sms-units`, {
        schoolID,
        items,
        message,
        recipientCount,
        phones,
    });
    return res.data;
}

export async function estimateFeeSms({ schoolID, type, payload }) {
    const res = await axios.post(`${API_BASE}/api/students/estimate-fee-sms-units`, {
        schoolID,
        type,
        ...payload,
    });
    return res.data;
}

export async function estimateDebtorsSms({ schoolID, list, classlist }) {
    const res = await axios.post(`${API_BASE}/api/students/estimate-debtors-sms-units`, {
        schoolID,
        list,
        classlist,
    });
    return res.data;
}

export async function estimateBulkbillSms(body) {
    const res = await axios.post(`${API_BASE}/api/students/estimate-bulkbill-sms-units`, body);
    return res.data;
}

export async function estimateBulkResultsSms(body) {
    const res = await axios.post(`${API_BASE}/api/students/estimate-bulk-results-sms-units`, body);
    return res.data;
}

export async function estimateSendResultsTextSms(body) {
    const res = await axios.post(`${API_BASE}/api/students/estimate-sendresultstext-sms-units`, body);
    return res.data;
}

export async function estimateSingleSms({ schoolID, phone, message }) {
    return estimateSmsUnitsGeneric({
        schoolID,
        items: [{ phone, message }],
    });
}

export function debounceSmsEstimate(fn, delay = 400) {
    let timer = null;
    return (...args) => {
        if (timer) clearTimeout(timer);
        timer = setTimeout(() => fn(...args), delay);
    };
}
